import { API_URL, getAuthHeaders } from './config';

export interface HealthProfile {
    user_id: string;
    height_cm?: number;
    weight_kg?: number;
    resting_hr?: number;
    max_hr?: number;
    data_consent: boolean;
    connected_services?: string[];
}

export interface MatchHealthStats {
    match_id: string;
    user_id: string;
    source: string;
    calories: number;
    avg_hr?: number;
    padel_fit_score?: number;
}

export const healthService = {
    getProfile: async (): Promise<HealthProfile> => {
        const response = await fetch(`${API_URL}/health/profile`, {
            headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error('Failed to fetch health profile');
        return response.json();
    },

    updateProfile: async (data: Partial<HealthProfile>): Promise<void> => {
        const response = await fetch(`${API_URL}/health/profile`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Failed to update health profile');
    },

    getMatchStats: async (matchId: string, durationMin: number = 60): Promise<MatchHealthStats> => {
        const response = await fetch(`${API_URL}/health/match-stats?matchId=${matchId}&duration=${durationMin}`, {
            headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error('Failed to fetch match stats');
        return response.json();
    },

    getStravaAuthUrl: async (callbackUrl: string): Promise<{ url: string }> => {
        const response = await fetch(`${API_URL}/health/auth/strava/url?callbackUrl=${encodeURIComponent(callbackUrl)}`, {
            headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error('Failed to get Strava URL');
        return response.json();
    },

    connectStrava: async (code: string): Promise<void> => {
        const response = await fetch(`${API_URL}/health/auth/strava/callback`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code }),
        });
        if (!response.ok) throw new Error('Failed to connect Strava');
    },

    disconnectService: async (provider: string): Promise<void> => {
        const response = await fetch(`${API_URL}/health/disconnect?provider=${provider}`, {
            method: 'POST',
            headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error(`Failed to disconnect ${provider}`);
    }
};
